type ColumnWithWidth = {
  id?: string
  width?: string
}

export const getColumnWidths = (columns: ColumnWithWidth[]) =>
  Object.fromEntries(
    columns.flatMap((column) =>
      column.id && column.width ? [[column.id, column.width]] : []
    )
  )
